import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=63200a34&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"
import style0 from "./Otp.vue?vue&type=style&index=0&id=63200a34&prod&lang=css"
import style1 from "./Otp.vue?vue&type=style&index=1&id=63200a34&prod&scoped=true&lang=css"
import style2 from "./Otp.vue?vue&type=style&index=2&id=63200a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63200a34",
  null
  
)

export default component.exports